import React, { useEffect, useState } from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { ReactSVG } from 'react-svg'
import NoImage from '../primitives/NoImage'

import FbIcon from '../../images/facebook_2.svg'
import EmailIcon from '../../images/email_2.svg'
import PrintIcon from '../../images/print.svg'
import ShareIcon from '../../images/share.svg'

const Hero = ({ recipe }) => {
    // const img = getImage(recipe.featuredImage)

    const desktopBanner = getImage(recipe.desktopBanner)
    const tabletBanner = getImage(recipe.tabletBanner)
    const mobileBanner = getImage(recipe.mobileBanner)

    const handlePrint = () => {
        console.log('printed')
        window.print();
    };

    const [currentUrl, setCurrentUrl] = useState('');
    const [copySuccess, setCopySuccess] = useState('');
    const [showTooltip, setShowTooltip] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
        setCurrentUrl(window.location.href);
        }
    }, []);

    const link = encodeURI(currentUrl)

    const mailText = `mailto:?subject=Checkout this Recipe on Dorot Gardens&body=We have this amazing recipe. ${link}`

    const copyToClipBoard = async copyMe => {
        try {
        await navigator.clipboard.writeText(copyMe);
        setCopySuccess('Copied!');
        setShowTooltip(true);
        setTimeout(() => setShowTooltip(false), 2000);
        } catch (err) {
        setCopySuccess('Failed to copy!');
        }
    }

    const tooltipStyle = {
        position: 'absolute',
        top: '-52px',
        right: '0',
        background: '#BD7AB3',
        color: '#fff',
        padding: '8px 10px',
        borderRadius: '14px',
        fontSize: '14px',
        display: showTooltip ? 'block' : 'none',
    };

    const arrowStyle = {
        content: '""',
        position: 'absolute',
        top: '-20px',
        right: '25px',
        width: '10px',
        height: '10px',
        background: '#BD7AB3',
        transform: 'rotate(45deg)',
        display: showTooltip ? 'block' : 'none',
    };

  return (
        <div id='recipe-inner' className='lg:min-h-[515px] 2xl:h-[687px] bg-dorot-purple 1024:flex print:h-[90vh]'>
            <div className='w-full 1024:w-[40%] lg:w-[51%]'>
              {desktopBanner && (
                <GatsbyImage
                  image={desktopBanner}
                  alt={recipe.title}
                  className="!hidden lg:!block h-[352px] 1024:w-full 1024:h-full lg:w-full lg:h-full transition-all ease-in"
                />
              )}
                  
              {tabletBanner && (
                <GatsbyImage
                  image={tabletBanner}
                  alt={recipe.title}
                  className="!hidden md:!block lg:!hidden md:h-[900px] 1024:h-full h-full w-full transition-all ease-in "
                />
              )}

              {mobileBanner && (
                <GatsbyImage
                  image={mobileBanner}
                  alt={recipe.title}
                  className="w-full md:!hidden h-[352px] transition-all ease-in "
                />
              )}
              {!desktopBanner && !tabletBanner && !mobileBanner && (
                <NoImage className="w-full h-[352px] md:h-[900px] 1024:h-full lg:h-full" />
              )}
            </div>

            <div className='pl-7.5 pr-7.5 pt-5 1024:py-10 1024:px-12 lg:py-10 lg:pl-20.5 lg:pr-18 1024:grow 1024:w-[60%] lg:w-[49%]'>
              <h1 id='recipe-title' className='text-white font-gelica font-semibold 1024:font-bold text-center 1024:text-left text-_3439 1024:text-_6058 print:justify-items-start'>{recipe.title}</h1>
              
              <p className='text-white font-goldplay text-_1625 hidden 1024:block 1024:mt-5 1024:text-_2025 font-semibold uppercase'>RECIPE BY: {recipe.author}</p>
              
              <div className='1024:border-white 1024:border-solid 1024:border-t-2 1024:border-b-2 1024:mt-10 lg:mt-10 1024:grid 1024:grid-cols-3 print:grid print:grid-cols-3 print:justify-items-start'>
                <div className='mt-[18px] 1024:mt-0 1024:border-solid 1024:border-white border-r 1024:py-2.5'>
                  <span className='text-white text-left 1024:text-center font-goldplay text-_2032 font-bold block'>serves</span>
                  <span className="text-white text-left 1024:text-center font-gelica text-_2430 1024:text-_3632 font-bold block">{recipe.serves || 'Varies'}</span>
                </div>

                <div className='mt-[18px] 1024:mt-0 1024:border-solid 1024:border-white border-r 1024:py-2.5'>
                  <span className='text-white text-left 1024:text-center font-goldplay text-_2032 font-bold block'>cooking time</span>
                  <span className="text-white text-left 1024:text-center font-gelica text-_2430 1024:text-_3632 font-bold block">{recipe.cookingTime || 'Varies'}</span>
                </div>

                <div className='mt-[18px] 1024:mt-0 1024:py-2.5'>
                  <span className='text-white text-left 1024:text-center font-goldplay text-_2032 font-bold block'>difficulty level</span>
                  <span className="text-white text-left 1024:text-center font-gelica text-_2430 1024:text-_3632 font-bold block">{recipe.difficulty || 'Varies'}</span>
                </div>

              </div>

              <span className='text-white font-goldplay text-_1625 block pt-8 pb-[21px] 1024:hidden lg:pt-4 font-semibold uppercase'>RECIPE BY: {recipe.author}</span>
                
              <div className='hidden 1024:block 1024:pt-[67px] lg:pt-[67px]'>
                <span className='text-_1625 text-white font-goldplay'>Share this recipe:</span>

                <div className='flex gap-[10px] pt-7 1024:pt-5'>
                  <button onClick={() => copyToClipBoard(link)} title='Copy to clipboard' className='copy-text relative'>
                    <ReactSVG 
                      beforeInjection={(svg) => {
                        svg.classList.add('recipe-share-icon')
                        svg.setAttribute('width', '40')
                        svg.setAttribute('height', '40')
                        svg.setAttribute('alt', 'share')
                      }}
                      src={ShareIcon} />
                    <div style={tooltipStyle}>{copySuccess}</div>
                    <div style={arrowStyle}></div>
                  </button>

                  <a href={mailText} title='Share on email'>
                    <ReactSVG 
                      beforeInjection={(svg) => {
                        svg.classList.add('recipe-share-icon')
                        svg.setAttribute('width', '40')
                        svg.setAttribute('height', '40')
                        svg.setAttribute('alt', 'email')
                      }}
                      src={EmailIcon} />
                  </a>

                  <a href={`https://www.facebook.com/sharer/sharer.php?u=${link}&t=${recipe.title}`} title='Share on Facebook'>
                    <ReactSVG 
                      beforeInjection={(svg) => {
                        svg.classList.add('recipe-email-icon')
                        svg.setAttribute('width', '40')
                        svg.setAttribute('height', '40')
                        svg.setAttribute('alt', 'facebook')
                      }}
                      src={FbIcon} />
                  </a>

                  <button onClick={()=> handlePrint()} title='Print recipe' className='relative'>
                    <ReactSVG 
                      beforeInjection={(svg) => {
                        svg.classList.add('recipe-email-icon')
                        svg.setAttribute('width', '160')
                        svg.setAttribute('height', '40')
                        svg.setAttribute('alt', 'print')
                      }}
                      className='relative'
                      src={PrintIcon} />
                    <span className='text-white text-_1025 absolute top-[20%] right-[20%] bottom-auto left-auto'>Print this recipe</span>
                  </button>
                </div>
              </div>

            </div>
        </div>
  )
}

export default Hero
